<template>
  <div class="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
    <div class="max-w-2xl w-full text-center space-y-8 py-12">
      <!-- Icône de succès -->
      <div class="flex justify-center">
        <div class="rounded-full bg-green-100 p-6">
          <svg class="w-16 h-16 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
      </div>

      <!-- Titre -->
      <div class="space-y-4">
        <TitleH1 class="text-3xl sm:text-4xl lg:text-5xl" titleText="Demande bien reçue !" />
        <Paragraph class="text-lg sm:text-xl text-gray-600">
          Merci pour votre demande. Nous avons bien pris en compte votre message et nous vous recontacterons dans les plus brefs délais.
        </Paragraph>
      </div>

      <!-- Message additionnel -->
      <div class="bg-olive bg-opacity-10 rounded-lg p-6">
        <p class="text-base sm:text-lg text-gray-700">
          Notre équipe reviendra vers vous sous 24 à 48 heures pour discuter de votre projet et répondre à toutes vos questions.
        </p>
      </div>

      <!-- Bouton retour -->
      <div class="pt-4">
        <Button textButton="Retour à l'accueil" dark @click="goToHome" class="mx-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import TitleH1 from '@/Components/Typography/Headings/TitleH1.vue';
import Paragraph from '@/Components/Typography/Body/Paragraph.vue';
import Button from '@/Components/Buttons/Button.vue';

export default {
  name: 'SuccessView',
  components: {
    TitleH1,
    Paragraph,
    Button,
  },
  methods: {
    goToHome() {
      this.$router.push({ name: 'home' });
    }
  }
}
</script>

<style scoped>
/* Animation d'entrée pour la page */
.min-h-screen {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
